import { render, staticRenderFns } from "./m-index.vue?vue&type=template&id=ef890aec&"
import script from "./m-index.vue?vue&type=script&lang=js&"
export * from "./m-index.vue?vue&type=script&lang=js&"
import style0 from "./m-index.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports